import React from 'react';
import { BottomNavigationAction, useTheme } from '@mui/material';
import { FooterBarProps } from './types';
import HomeFilledIcon from '@mui/icons-material/HomeFilled';
import { StyledBottomNavigation } from './styles';
import { useNavigate } from 'react-router-dom';

const FooterBar: React.FC<FooterBarProps> = (props) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const handleClick = React.useCallback((e: React.SyntheticEvent, newValue: any) => {
        switch(newValue){
            case 0:
                navigate('/home');
                break;
            case 1:
                window.location.href = "https://ventasizzi.zendesk.com/hc/es-419";
                break;
            default:
                navigate('/home');
                break;
        }

    },[navigate]);

    return (
        <StyledBottomNavigation
            theme={theme}
            value={props.active}
            onChange={handleClick}
        >
        <BottomNavigationAction label="Home" icon={<HomeFilledIcon />} />
      </StyledBottomNavigation>
    )
}

export default FooterBar